import ko from 'knockout';
import $ from 'jquery';

// TODO: This and logi-common seem to be doing similar things. Consider merging them into a single module.

function QueryCommon() {}

function appendCondition(queryGroups, lhs, operator, rhs, valueType, lhstitle, optitle, valuename) {
    var result = [];
    if (queryGroups && (queryGroups.length > 0)) {
        result = JSON.parse(ko.toJSON(queryGroups));
    }
    else {
        result.push({ conditions: [] });
    }

    var group = result[0];
    var conditions = group.conditions;

    var condition = { selectedLhs: lhs, selectedOperator: operator, valueType: valueType, selectedConjunction: "AND" };

    if ($.isArray(rhs)) {
        condition.selectedRhs = rhs;
        condition.listtype = true;
    }
    else
    {
        condition.rhsText = rhs;
        condition.listtype = false;
    }

    condition.lhstitle = lhstitle;
    condition.optitle = optitle;
    condition.valuename = valuename;

    conditions.push(condition);

    return result;
}

QueryCommon.prototype.getValueName = function(sourceObs, selObs, idCol, nameCol) {
    var result = [];

    if (sourceObs && sourceObs() && (sourceObs().length > 0) && selObs && selObs() && (selObs().length > 0)) {
        var src = sourceObs();

        for (var i = 0; i < src.length; i++) {
            if ($.inArray(src[i][idCol], selObs()) >= 0) {
                result.push(src[i][nameCol]);
            }
        }
    }

    return result;
};

QueryCommon.prototype.appendCondition = function(conditionGroups, lhs, operator, rhs, valueType, lhstitle, optitle, valuename) {
    if (!lhs || !rhs || $.isEmptyObject(rhs)) {
        return conditionGroups;
    }

    var conditiongroups = [];

    if (!conditionGroups || (conditionGroups === '1=1') || ((typeof (conditionGroups) === 'object') && conditionGroups.WhereCondition)) {
        conditiongroups = [];
    }
    else if (typeof (conditionGroups) === 'string') {
        conditiongroups = JSON.parse(conditionGroups);
    }
    else {
        conditiongroups = conditionGroups;
    }
    return appendCondition(conditiongroups, lhs, operator, rhs, valueType, lhstitle, optitle, valuename);
};

QueryCommon.prototype.removeTimePortion = function (dateTimeString) {
    var t = dateTimeString.toLowerCase().indexOf("t");

    if (t > 0) {
        return dateTimeString.substring(0, t);
    }

    return dateTimeString;
};

QueryCommon.prototype.buildConditionGroupsFromExpression = function(groups, expression) {
    var tokens = expression.split('=');

    if (tokens.length > 1) {
        groups = appendCondition(groups, tokens[0].trim(), '=', tokens[1].trim(), 'integer');
        return groups;
    }

    tokens = expression.split('between');

    if (tokens.length < 2) {
        return groups;
    }

    var tokens2 = tokens[1].split('and');

    groups = appendCondition(groups, tokens[0].trim(), '>=', tokens2[0].trim(), 'integer');
    groups = appendCondition(groups, tokens[0].trim(), '<=', tokens2[1].trim(), 'integer');
    return groups;
};


QueryCommon.prototype.buildConditionGroupsFromJson = function(groups, jsonObj) {
    var keys = Object.keys(jsonObj);

    keys.forEach(function(key) {
        groups = appendCondition(groups, key, '=', jsonObj[key], 'string');
    });
    return groups;
};

QueryCommon.prototype.GetWebexViewLevelOptions2 = function (webexSite, hierarchy, daterange, urlparamobject, dataFilter) {
    if (dataFilter === "1=1") {
        dataFilter = null;
    }

    var result = {

        WhereCondition: (dataFilter && (dataFilter.length > 0)) ? ko.toJSON(dataFilter) : "1=1"
    };

    if (daterange) {

        result.inpStartDate = daterange.startDate.format("YYYY/MM/DD");
        result.inpEndDate = daterange.endDate.format("YYYY/MM/DD");
    }

    var mainFilter = [];

    if (hierarchy && (hierarchy.hierarchyId !== -1)) {
        mainFilter = appendCondition(mainFilter, 'hierarchyID', '=', hierarchy.hierarchyId, 'numeric');
        mainFilter = appendCondition(mainFilter, 'hierarchyPath', '=', hierarchy.paths);
    }

    if (webexSite) {
        mainFilter = appendCondition(mainFilter, 'sysSystemID', 'in', '(' + webexSite + ')', 'numeric');
    }

    result.mainFilter = (mainFilter && (mainFilter.length > 0)) ? ko.toJSON(mainFilter) : "";

    $.extend(true, result, urlparamobject);

    return result;
};

function inArrayIgnoreCase(item, list) {
    for (var i = 0; i < list.length; i++) {
        if (list[i].toLowerCase() === item.toLowerCase()) {
            return true;
        }
    }
    return false;
}

QueryCommon.prototype.removeConditions = function(conditionGroups, lhsListToRemove) {
    if (!conditionGroups || (conditionGroups === "1=1") || $.isEmptyObject(conditionGroups) || !conditionGroups[0] || !conditionGroups[0].conditions || $.isEmptyObject(conditionGroups[0].conditions) || !lhsListToRemove || $.isEmptyObject(lhsListToRemove)) {
        return { removed: [], remaining: conditionGroups };
    }

    var conditions = conditionGroups[0].conditions;
    var conditionsToDelete = [];

    for (var i = 0; i < conditions.length; i++) {
        conditions[i].selectedLhs = conditions[i].selectedLhs.replace(/^.*\./, '');

        if (inArrayIgnoreCase(conditions[i].selectedLhs, lhsListToRemove)) {
            conditionsToDelete.push(i);
        }
    }

    var removedConditions = [];
    for (var j = conditionsToDelete.length - 1; j >= 0; j--) {
        removedConditions.push(conditions[conditionsToDelete[j]]);
        conditions.splice(conditionsToDelete[j], 1);
    }

    return { removed: removedConditions, remaining: conditionGroups };
};

QueryCommon.prototype.getListValues = function (conditions, lhs) {
    if (!conditions || $.isEmptyObject(conditions)) {
        return [];
    }

    var result = [];

    for (var i = 0; i < conditions.length; i++) {
        if (conditions[i].selectedLhs === lhs) {
            result = conditions[i].selectedRhs;
            break;
        }
    }

    return result;
};

QueryCommon.prototype.getListValuesDictionary = function (conditions, lhsList) {
    if (!lhsList || $.isEmptyObject(lhsList)) {
        return {};
    }

    var conditions2 = [];

    if (conditions && !$.isEmptyObject(conditions)) {
        conditions2 = conditions;
    }

    var result = {};

    for (var i = 0; i < lhsList.length; i++) {
        var lhs = lhsList[i];
        result[lhs] = [];

        for (var j = 0; j < conditions2.length; j++) {
            if (conditions2[j].selectedLhs.toLowerCase() === lhs.toLowerCase()) {
                result[lhs] = conditions2[j].selectedRhs;
                break;
            }
        }
    }

    return result;
};

QueryCommon.prototype.parseConditions = function(viewLevelOptionsObs, lhsList) {
    var savedWhereCondition = viewLevelOptionsObs && viewLevelOptionsObs() && viewLevelOptionsObs().WhereCondition;

    return this.parseConditionsFromString(savedWhereCondition);
};

QueryCommon.prototype.parseConditionsFromString = function(savedWhereCondition, lhsList) {
    var flexQueryWhereClause = savedWhereCondition;

    var valuesDict = {};

    if (savedWhereCondition && (savedWhereCondition !== '1=1')) {
        var condParsed = savedWhereCondition;
        if (typeof savedWhereCondition === 'string') {
          var condParsed = JSON.parse(savedWhereCondition);
        }

        var conditionGroups = this.removeConditions(condParsed, lhsList);

        flexQueryWhereClause = conditionGroups.remaining;

        valuesDict = this.getListValuesDictionary(conditionGroups.removed, lhsList);
    } else {
        //get an array for each lhs item
        valuesDict = this.getListValuesDictionary([], lhsList);
    }

    return { flexQueryWhereConditionObj: flexQueryWhereClause, valuesDictionary: valuesDict };
};

export default QueryCommon;
